export default "__VITE_ASSET__D50IzrKr__"